var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfdownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_xD83C__xDFD7_-Grundlagen:-Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-899.000000, -3348.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atom_x2F_icon_x2F_24px_x2F_pdf-download",
    transform: "translate(899.000000, 3348.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.44287,7.90627h2.00928c1.15674,0,1.82568,0.71387,1.82568,1.72656 c0,1.0166-0.68115,1.71582-1.85303,1.71582H2.51953v1.65137H1.44287V7.90627z M3.25098,10.48538 c0.6167,0,0.91748-0.34766,0.91748-0.85254c0-0.50781-0.30078-0.8457-0.92236-0.8457H2.51953v1.69824H3.25098z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.97705,13.00002V7.90627h1.82031c1.53711,0,2.47754,0.95508,2.47754,2.54199 c0,1.5918-0.94043,2.55176-2.49219,2.55176H5.97705z M7.73779,12.07717c0.95752,0,1.4624-0.49219,1.4624-1.62891 c0-1.13184-0.50488-1.61914-1.45996-1.61914H7.05371v3.24805H7.73779z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.06787,7.90627h3.37256v0.8877h-2.2959v1.21387h2.07227v0.8877h-2.07227v2.10449h-1.07666V7.90627z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21,8c0-0.46582-0.18372-0.9129-0.51129-1.24414l-5.76068-6.23071C14.39569,0.18909,13.94269,0,13.47009,0 H6.53845C5.13654,0,4,1.13647,4,2.53845v3.84613h2V2.53845C6,2.24109,6.24109,2,6.53845,2h6.83533L19,8v4.0799 c0.70642,0.10181,1.37775,0.30835,2,0.60529V8z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,20v-5.61542H4V20c0,1.40192,0.59802,2,2,2h5.68518c-0.29694-0.62225-0.50348-1.29358-0.60529-2H6z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18,14c-2.76141,0-4.99994,2.23859-4.99994,5S15.23859,23.99994,18,23.99994S23,21.76141,23,19 S20.76141,14,18,14z M18,21.70703l-2.35352-2.35352l0.70703-0.70703L17.5,19.79297V16.5h1v3.29297l1.14648-1.14648 l0.70703,0.70703L18,21.70703z",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfdownload);
export default __webpack_public_path__ + "static/media/pdfdownload.7bd170c8a3159e09ea4b410a6fd8a9fb.svg";
export { ForwardRef as ReactComponent };